"use client"
import { useEffect } from "react"

const PrivacyPage = ({ onBack }) => {
  // Scroll to top when the component mounts
    useEffect(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []); // Empty dependency array ensures this runs only once on mount
  return (
    <div className="pt-40 pb-16 bg-stone-50 min-h-screen">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <button onClick={onBack} className="mb-8 text-emerald-800 hover:text-emerald-700 font-medium">
          ← Back to Home
        </button>

        <div className="bg-white rounded-lg shadow-md p-8">
          <h1 className="text-3xl font-bold text-charcoal-800 mb-2">Mediwhistle – Privacy Policy</h1>
          <p className="text-stone-600 mb-8">Effective Date: September 2025</p>

          <div className="prose prose-stone max-w-none">
            <p className="mb-6">
              At Mediwhistle, we respect your privacy. This policy explains how we collect and use personal information
              when you use our website or ordering platform.
            </p>

            <h2 className="text-xl font-semibold text-charcoal-800 mb-4">Information We Collect</h2>
            <p className="mb-4">We may collect information when you:</p>
            <ul className="list-disc pl-6 mb-6 space-y-2">
              <li>Submit an enquiry or support request.</li>
              <li>Access the ordering platform as a healthcare professional.</li>
              <li>Report an issue with a device.</li>
            </ul>
            <p className="mb-6">
              This may include your name, contact details, organisation, professional role, and the details you choose
              to share with us.
            </p>

            <h2 className="text-xl font-semibold text-charcoal-800 mb-4">How We Use Your Information</h2>
            <p className="mb-4">We use this information to:</p>
            <ul className="list-disc pl-6 mb-6 space-y-2">
              <li>Respond to your enquiry or support request.</li>
              <li>Provide access to the ordering platform.</li>
              <li>Manage orders and investigate product or safety issues.</li>
              <li>Meet legal or regulatory obligations.</li>
            </ul>

            <h2 className="text-xl font-semibold text-charcoal-800 mb-4">When Information Is Shared</h2>
            <p className="mb-4">We only share information where it's necessary to:</p>
            <ul className="list-disc pl-6 mb-6 space-y-2">
              <li>Deliver services (e.g. through our secure email or hosting providers).</li>
              <li>Respond to your enquiry (e.g. involving a pharmacy or distributor if needed).</li>
              <li>Meet legal requirements (e.g. reporting safety issues to the TGA).</li>
            </ul>
            <p className="mb-6">We never sell your information to anyone.</p>

            <h2 className="text-xl font-semibold text-charcoal-800 mb-4">Protecting Your Information</h2>
            <p className="mb-6">
              We take reasonable steps to protect your information from misuse or unauthorised access. However, no
              online system is completely secure, and you use the platform at your own risk.
            </p>

            <h2 className="text-xl font-semibold text-charcoal-800 mb-4">Your Rights</h2>
            <p className="mb-4">You can:</p>
            <ul className="list-disc pl-6 mb-6 space-y-2">
              <li>Ask what personal information we hold about you.</li>
              <li>Request corrections if your details are inaccurate.</li>
              <li>Disable cookies in your browser, though some features may not work as well.</li>
            </ul>

            <h2 className="text-xl font-semibold text-charcoal-800 mb-4">Updates</h2>
            <p className="mb-6">
              We may update this policy from time to time. The latest version will always be published here.
            </p>

            <h2 className="text-xl font-semibold text-charcoal-800 mb-4">Contact Us</h2>
            <p className="mb-6">
              For any questions about this policy, please contact:
              <br />
              Email:{" "}
              <a href="mailto:admin@mediwhistle.com.au" className="text-emerald-800 hover:text-emerald-700 underline">
                admin@mediwhistle.com.au
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PrivacyPage
